import { render, staticRenderFns } from "./UsuarioAgregar.vue?vue&type=template&id=c65d4ebe"
import script from "./UsuarioAgregar.vue?vue&type=script&lang=js"
export * from "./UsuarioAgregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports